<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="false">
  <p style="color: white">Loading...</p>
</ngx-spinner>

<div class="text-center">
  <img *ngIf="isLoading" src="./assets/images/loading04.gif" style="width: 10rem;">
</div>

<div class="content-wrapper" style="min-height: 307px">
  <div class="row" *ngIf="userdata.userlevel !== '15'">
    <div class="col-lg-12">
      <div class="row">
        <div class="card bg-primary">
          <div class="card-header">ระบบขอเงินส่งเสริมออนไลน์ 2566/2567
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>
          <div class="card-body" [formGroup]="askformoney">
            <div class="card" style="color: black">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-8">
                    <div class="input-group mb-3" *ngIf="famerlist != null">
                      <span class="input-group-text">เลือกชาวไร่</span>
                      <input type="text" class="form-control" list="farmer" placeholder="โควตา 10 หลัก" id="codefm"
                        (change)="goloaddata()" />
                      <datalist id="farmer">
                        <option *ngFor="let item of famerlist">
                          {{ item.fmcode_b1 }} {{ item.fmname }}_{{ item.cnt }}_แปลง_โซน-{{
                          item.SUPZONE }}
                          <lable *ngIf="item.approve === 'Y'">เบิกได้</lable>
                          <lable *ngIf="item.PromiseIN == 0">สัญญายังไม่ผ่าน</lable>
                          <lable *ngIf="item.zoneban === 'Y'">อยู่โซนต้องห้าม</lable>
                        </option>
                      </datalist>
                      <div class="input-group-append">
                        <button class="btn btn-default float-right" (click)="clearFm();">กรอกใหม่</button>
                      </div>
                    </div>
                    <div class="col-md-12 ml-md">
                      <table style="width:100%">
                        <tr style="text-align:center">
                          <th>วงเงินทั้งหมด</th>
                          <th>ยอดหนี้ปี 66/67 </th>
                          <th>วงเงินที่ใช้ไป</th>
                          <th>วงเงินที่ขอเกี้ยว </th>
                          <th>วงเงินเบิกปัจจัย</th>
                          <th>วงเงินคงเหลือ</th>
                        </tr>
                        <tr style="text-align:center">
                          <td>{{credit| number:'1.2-2'}}</td>
                          <td>{{RSUM_long| number:'1.2-2'}}</td>
                          <td>{{sum_money_amt| number:'1.2-2'}}</td>
                          <td>{{sum_money_amt1| number:'1.2-2'}}</td>
                          <td>{{sum_money_amt2| number:'1.2-2'}}</td>
                          <td style="color: red;">{{limit| number:'1.2-2'}}</td>
                        </tr>
                      </table>
                    </div>
                    <hr />
                    <div class="card-header">ข้อมูลแปลงปี 66/67</div>
                    <!--<p *ngFor="let item of canget">
                                          วงเงินทั้งหมด :
                                          {{ item.sumlimit.toLocaleString() }} วงเงินที่ขอแล้ว :
                                          {{ item.money_amt.toLocaleString() }} วงเงินคงเหลือ :
                                          {{ item.leftlimit.toLocaleString() }}
                                        </p>-->
                    <div class="card">
                      <div class="card-body table-responsive p-2" style="height: 500px">
                        <table #tb_data class="table table-hover table-head-fixed text-nowrap">
                          <thead>
                            <tr class="headText text-primary" style="text-align:center">
                              <th>_</th>
                              <th>เลขแปลง</th>
                              <th>โซน</th>
                              <th>นสส.</th>
                              <th>ประเภท</th>
                              <th>กรรมสิทธิ์</th>
                              <th>พื้นที่</th>
                              <th>ปลูกเสร็จ</th>
                              <th>วงเงิน</th>
                              <th>เงินที่ขอ</th>
                              <th>เลือก</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr style="text-align:center" *ngFor="let item of dataonefarmer; let i = index;">
                              <td>{{ i+1 }}</td>
                              <td>{{ item.intlandno }}</td>
                              <td>{{ item.supzone }}</td>
                              <td>{{ item.supcode }}</td>
                              <td>{{ item.CaneTypeName }}</td>
                              <td>
                                <label *ngIf="item.Plottype === '1'">เช่า</label>
                                <label *ngIf="item.Plottype === '2'">ตนเอง</label>
                              </td>
                              <td style="text-align:right">{{ item.landvalue | number:'1.2-2' }}
                              </td>
                              <td>{{ item.PlantDateTH }}</td>
                              <td style="text-align:right">{{ item.credit_amount | number:'1.2-2'
                                }}</td>
                              <td style="text-align:right">
                                <div *ngFor="let li of crdamt">
                                  <label *ngIf=" li.intlandno.trim() === item.intlandno.trim() ">{{
                                    (li.sum_money_amt) | number:'1.2-2' }}</label>
                                </div>
                              </td>
                              <td>
                                <button class="btn btn-success" (click)="snaponedata(item.itid);">
                                  <i class="fas fa-check-circle"></i></button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <!-- ฟอร์มขอเบิกสินเชื่อ -->
                  <div class="col-md-4" [hidden]="ckfarmer">
                    <div class="card" *ngIf="dataonefarmer.length>0">
                      <div class="card-header bg-warning">
                        ฟอร์มขอเบิกเงินส่งเสริมปี 66/67 [ <label id="fmnamelable"></label> ]
                      </div>
                      <div class="card-body" [formGroup]="askformoney">
                        <input type="text" class="form-control" id="plantnum" placeholder="หมายเลขแปลง" disabled />
                        <br />
                        <div class="row align-items-center">
                          <div class="col-md-5">
                            <div class="check-control">
                              <div *ngFor="let item of subtype0">
                                <div class="form-check">
                                  <label class="form-check-label">
                                    <input formControlName="t0" value="{{item.l_id}}" class="form-check-input"
                                      type="radio" (change)="SubTypeSelectM(item.l_id)" name="t0" id="{{item.l_id}}">
                                    {{item.doc}}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-7">
                            <div *ngFor="let item of subtype1">
                              <button type="button" [ngClass]="{'btn btn-outline-success btn-block' : true }"
                                name="subtype" [value]="item.id" (click)="SubTypeSelectS(item.id,item.doc)">{{item.doc}}
                              </button>
                              <!-- <input *ngIf="item.ck_used.trim()==='1'" type="radio" name="selectqueue" formControlName="selectqueue"
                                 value="{{item.q_id}}"><label for="female">{{item.q_id}}</label> -->
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="input-group mb-3">
                          <span class="input-group-text">รายการที่เลือก</span>
                          <input type="text" class="form-control" id="sumreason" placeholder="เลือกรายการ"
                            [value]="sc_docA" [disabled]="true" />
                        </div>
                        <div class="input-group mb-3">
                          <span class="input-group-text">หมายเหตุ </span>
                          <input type="text" class="form-control" id="anyreason" placeholder="คำอธิบาย"
                            formControlName="comment" required />
                        </div>
                        <div class="input-group mb-3">
                          <span class="input-group-text">จำนวนเงิน</span>
                          <input type="number" min="1.00" step="1.00" data-number-to-fixed="2" class="form-control"
                            id="countmoney" placeholder="0" formControlName="count" required />
                        </div>
                        <!--<input type="file" class="form-control" id="customFile" accept="image/png, image/jpeg" (change)="onFileUpload($event.target.files)"/>-->
                        <!-- <label class="custom-file-label" for="customFile">เลือกไฟล์</label> -->
                        <hr />
                        <div class="float-left" *ngIf="sel_landno.length>0">
                          <button class="btn btn-warning" (click)="gosave()"><i class="far fa-save"></i> บันทึก
                          </button>
                        </div>
                        <div class="float-right">
                          <button class="btn btn-info float-right" (click)="cleartext()">
                            กรอกใหม่ </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- ฟอร์มขอเบิกสินเชื่อ -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ข้อมูลการขอสินเชื่อออนไลน์ปี 64/65 -->
      <div class="row">
        <div class="card">
          <div class="card-header bg-primary">
            <b>ข้อมูลการขอสินเชื่อออนไลน์ปี 66/67</b>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" (click)="getfinancebyzone();"><i
                  class="fas fa-sync"></i></button>
            </div>
          </div>
          <div class="card-body">
            <table #moneydata
              class="table table-sm table-striped table-hover table-head-fixed table-bordered text-nowrap">
              <thead>
                <tr>
                  <th>เลขที่</th>
                  <th>วันที่</th>
                  <th>ชื่อ</th>
                  <th>แปลง</th>
                  <th>ประเภทเกี้ยว</th>
                  <th>เหตุผล</th>
                  <th>จำนวนเงิน</th>
                  <th>สถานะ</th>
                  <!--<td><i class="fas fa-print"></i> พิมพ์</td>-->
                  <th><i class="fas fa-ban"></i> ยกเลิก</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of datafinance" [ngClass]="item.over_limit == '1' ? 'bg-danger' : ''">
                  <td>{{ item.docid }}</td>
                  <td>{{ item.datepost_th }}</td>
                  <td>{{ item.fmname }}</td>
                  <td>{{ item.intlandno }}</td>
                  <td>{{ item.type_money_sub }}</td>
                  <td>{{ item.comment1 }}</td>
                  <td>{{ item.money_amt | number }}</td>
                  <td>{{ item.docdesc }}</td>
                  <!--<td> 
                    <a [routerLink]="['/printaskformoney']" routerLinkActive="active" target="_blank" >
                      <button class="btn btn-warning" (click)="getfmcode(item.fmcode)" >
                        <i class="fas fa-print"></i>
                      </button>
                    </a>
                  </td>-->
                  <td>
                    <!--<button type="button" class="btn btn-outline-danger" *ngIf="item.doc_status == 0" (click)="cancledoc_id(item.docid)"><i class="material-icons" style="color:red">close</i></button>-->
                    <button mat-flat-button color="warn" (click)="cancledoc_id(item)"
                      *ngIf="item.doc_status == 0"><mat-icon>highlight_off</mat-icon></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- ข้อมูลการขอสินเชื่อออนไลน์ปี 64/65 -->
    </div>
  </div>

  <div class="row" *ngIf="userdata.userlevel === '15'">
    <div class="col-lg-12">
      <!-- ข้อมูลการขอสินเชื่อออนไลน์ปี 64/65 -->
      <div class="row">
        <div class="card">
          <div class="card-header bg-primary">
            ข้อมูลการขอสินเชื่อออนไลน์ปี 66/67
            <b class="text-warning">เกินวงเงิน</b>
            <div class="card-tools">
              <button (click)="getfinancebyzone()" type="button" class="btn btn-tool" title="รีเฟรซข้อมูล"><i
                  class="fas fa-sync-alt"></i></button>
              <!--<button type="button" class="btn btn-tool" data-card-widget="card-refresh" data-source="widgets.html" data-source-selector="#card-refresh-content" data-load-on-init="false"><i class="fas fa-sync-alt"></i></button>
              <button type="button" class="btn btn-tool" data-card-widget="maximize"><i class="fas fa-expand"></i></button>
              <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i></button>
              <button type="button" class="btn btn-tool" data-card-widget="remove"><i class="fas fa-times"></i></button> -->
            </div>
          </div>
          <div class="card-body">
            <table #moneydata class="table">
              <thead>
                <tr>
                  <td>เลขที่</td>
                  <td>วันที่</td>
                  <td>ชื่อ</td>
                  <td>แปลง</td>
                  <td>ประเภทเกี้ยว</td>
                  <td>เหตุผล</td>
                  <td>จำนวนเงิน</td>
                  <td>สถานะ</td>
                  <td><i class="fas fa-bars"></i> Action</td>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of datafinance">
                  <td>{{ item.docid }}</td>
                  <td>{{ item.datepost | adtob }}</td>
                  <td>{{ item.fmname }}</td>
                  <td>{{ item.intlandno }}</td>
                  <td>{{ item.type_money_sub }}</td>
                  <td>{{ item.comment1 }}</td>
                  <td>{{ item.money_amt.toLocaleString() }}</td>
                  <td>{{ item.docdesc }}</td>
                  <td class="">
                    <button
                      (click)="forwardtoFN(item.docid, item.money_amt, item.comment1, item.fmname, item.datepost_th)"
                      *ngIf="item.doc_status == 2" type="button" class="btn  btn-sm btn-link" title="ส่งต่อสินเชื่อ"><i
                        class="fas fa-forward"></i></button>
                    <a [routerLink]="['/printaskformoney']" routerLinkActive="active" target="_blank">
                      <!---- <button 
                        (click)="getfmcode(item.fmcode)" type="button" class="btn  btn-sm btn-link" title="พิมพ์ใบแนบเกี้ยว">
                        <i class="fas fa-print"></i>
                      </button>-->
                    </a>
                    <!--<button type="button" class="btn  btn-sm btn-link" *ngIf="item.doc_status == 2 || item.doc_status == 0" title="ยกเลิกเกี้ยว" (click)="cancledoc_id(item.docid)">
                      <i class="fas fa-ban"></i></button>-->
                    <button type="button" class="btn btn-sm btn-outline-danger"
                      *ngIf="item.doc_status == 2 || item.doc_status == 0" title="ยกเลิกเกี้ยว"
                      (click)="cancledoc_id(item)"><i class="fa fa-close"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- ข้อมูลการขอสินเชื่อออนไลน์ปี 64/65 -->
    </div>
  </div>
</div>


<!-- Modal กลุ่มบำรุง -->
<div class="modal fade" id="forwardtofn" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <form class="needs-validation" #frm_forwardfn="ngForm">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header bg-primary">
          <h1><mat-icon>forward</mat-icon> ส่งต่อเกี้ยวไปสินเชื่อ</h1>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row mt-1">
            <blockquote class="blockquote">
              <p class="text-primary">{{ valuesTomodal[3] }}</p>
              <footer class="blockquote-footer">เลขที่คำขอ {{ valuesTomodal[0] }} เมื่อ {{
                valuesTomodal[4] }}</footer>
            </blockquote>
          </div>

          <input type="hidden" #e_docid="ngModel" ngModel name="e_docid" id="e_docid" [(ngModel)]="valuesTomodal[0]"
            readonly required>

          <div class="row mt-1">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">จำนวนเงินที่ขอ </span>
              </div>
              <input #e_money_amt="ngModel" ngModel name="e_money_amt" id="e_money_amt" class="form-control"
                [ngClass]="{ 'is-invalid' : e_money_amt.invalid && (e_money_amt.dirty || e_money_amt.touched)}"
                type="number" [(ngModel)]="valuesTomodal[1]" required>
              <!-- (keyup)="CommaFormatted($event)"
                (keydown)="numberCheck($event)" -->
              <div class="invalid-feedback">
                <span *ngIf="e_money_amt.hasError('required')">กรุณากรอกจำนวนเงินที่ขอ</span>
              </div>
            </div>
          </div>
          <div class="row mt-1">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">เหตุผลการขอเกี้ยว </span>
              </div>
              <input #e_comment1="ngModel" ngModel name="e_comment1" id="e_comment1" class="form-control"
                [ngClass]="{ 'is-invalid' : e_comment1.invalid && (e_comment1.dirty || e_comment1.touched)}" type="text"
                [(ngModel)]="valuesTomodal[2]" required>
              <div class="invalid-feedback">
                <span *ngIf="e_comment1.hasError('required')">กรุณากรอกจำนวนเงินที่ขอ</span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button (click)="saveforwardtoFN(frm_forwardfn.value)" [disabled]="frm_forwardfn.invalid" type="submit"
            class="btn btn-outline-success" data-dismiss="modal">
            <i class="fas fa-save"></i> Save
          </button>
          <button type="button" class="btn btn-outline-warning" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </form>
</div>
<!-- MOdal -->
<app-footer></app-footer>